module.exports = __webpack_public_path__ + "static/media/Muli-ExtraLight.172255c5.eot";